import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import {
  deleteData,
  findData,
  recordFiltering,
} from '~/store/modules/usuarios/actions';

import MyForm from './form';

function Usuarios() {
  const redux = useSelector((state) => state.usuarios);

  const optStatus = useMemo(
    () => [
      { value: 'Ativo', label: 'S' },
      { value: 'Inativo', label: 'N' },
    ],
    []
  );

  const header = useMemo(
    () => [
      {
        id: 'usua_cod_usua',
        label: 'Login',
        align: 'center',
        filter: { type: 'text' },
      },
      { id: 'usua_nome', label: 'Nome', filter: { type: 'text' } },
      { id: 'perf_descricao', label: 'Perfil', filter: { type: 'text' } },
      { id: 'usua_email', label: 'Email', filter: { type: 'text' } },
      {
        id: 'usua_st_reg',
        label: 'Status',
        formatted: (value) => optStatus.find((f) => f.label === value).value,
        filter: { type: 'select', options: optStatus },
      },
    ],
    [optStatus]
  );

  return (
    <UnidataTable
      fixed
      header={header}
      read={recordFiltering}
      remove={deleteData}
      find={findData}
      form={MyForm}
      redux={redux}
      title="Usuários"
      detach="rownum"
      maxWidth="md"
      keys={['usua_cod_usua']}
    />
  );
}

export default Usuarios;
